import { Check, Minus } from 'lucide-react';
import { COMPARISON_ROWS } from '../psychologistLandingData';

export function PsychologistComparisonTable() {
	return (
		<div className="overflow-hidden rounded-2xl border border-brand-orange/10 bg-[#fffcfb] shadow-sm transition-all duration-300 hover:border-brand-orange/25 hover:shadow-lg hover:shadow-brand-orange/10">
			<div className="overflow-x-auto">
				<table className="w-full min-w-[520px] border-collapse text-left text-sm">
					<thead>
						<tr className="border-b border-brand-orange/10 bg-white/80">
							<th className="px-6 py-4 text-xs font-bold uppercase tracking-[0.14em] text-gray-400">
								Recurso
							</th>
							<th className="px-6 py-4 text-xs font-bold uppercase tracking-[0.14em] text-gray-400">
								Plataformas comuns
							</th>
							<th className="bg-brand-orange/5 px-6 py-4 text-xs font-bold uppercase tracking-[0.14em] text-brand-orange">
								Plumaa
							</th>
						</tr>
					</thead>
					<tbody>
						{COMPARISON_ROWS.map((row, index) => (
							<tr
								key={row.feature}
								className={
									index < COMPARISON_ROWS.length - 1
										? 'border-b border-brand-orange/5 transition-colors hover:bg-brand-orange/[0.03]'
										: 'transition-colors hover:bg-brand-orange/[0.03]'
								}
							>
								<td className="px-6 py-4 font-medium text-[#3d3431] transition-colors">
									{row.feature}
								</td>
								<td className="px-6 py-4 text-zinc-400 transition-colors">
									<span className="flex items-center gap-2">
										<Minus className="h-4 w-4 shrink-0 text-zinc-300" />
										{row.others}
									</span>
								</td>
								<td className="bg-brand-orange/[0.03] px-6 py-4 transition-colors hover:bg-brand-orange/[0.08]">
									<span
										className={
											row.plumaaHighlight
												? 'flex items-center gap-2 font-semibold text-brand-orange'
												: 'flex items-center gap-2 font-medium text-[#3d3431]'
										}
									>
										<Check className="h-4 w-4 shrink-0" />
										{row.plumaa}
									</span>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
